(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.custom-slider').forEach(slider => {
    const track = slider.querySelector('.custom-slider-track');
    const originalSlides = Array.from(track.children);
    const showArrows = slider.dataset.showArrows === 'true';
    const autoScroll = slider.dataset.autoScroll === 'true';
    const interval = parseInt(slider.dataset.interval) || 3000;
    const visibleCount = window.innerWidth < 768 ? 1 : 4;

    let isAnimating = false;
    let slideWidth;

    // Clone for infinite loop
    const prependClones = originalSlides.slice(-visibleCount).map(slide => slide.cloneNode(true));
    const appendClones = originalSlides.slice(0, visibleCount).map(slide => slide.cloneNode(true));
    prependClones.forEach(clone => track.insertBefore(clone, track.firstChild));
    appendClones.forEach(clone => track.appendChild(clone));

    let allSlides = Array.from(track.children);
    let index = visibleCount;

    function calculateSlideWidth() {
     const gap = parseFloat(getComputedStyle(track).gap) || 0;
     slideWidth = allSlides[0].getBoundingClientRect().width + gap;
    }

    function updatePosition(animate = true) {
      track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      track.style.transform = `translateX(-${index * slideWidth}px)`;
    }

    function scrollForward() {
      if (isAnimating) return;
      isAnimating = true;
      index++;
      updatePosition(true);

      setTimeout(() => {
        if (index >= allSlides.length - visibleCount) {
          index = visibleCount;
          updatePosition(false);
        }
        isAnimating = false;
      }, 500);
    }

    function scrollBackward() {
      if (isAnimating) return;
      isAnimating = true;
      index--;
      updatePosition(true);

      setTimeout(() => {
        if (index < visibleCount) {
          index = allSlides.length - visibleCount * 2;
          updatePosition(false);
        }
        isAnimating = false;
      }, 500);
    }

    // Auto scroll
    if (autoScroll) {
      setInterval(scrollForward, interval);
    }

    // Arrows
    if (showArrows) {
      slider.querySelector('.slider-arrow.next')?.addEventListener('click', scrollForward);
      slider.querySelector('.slider-arrow.prev')?.addEventListener('click', scrollBackward);
    }

    // Recalculate on resize
    window.addEventListener('resize', () => {
      calculateSlideWidth();
      updatePosition(false);
    });

    calculateSlideWidth();
    updatePosition(false);

    // Prevent image dragging
    track.querySelectorAll('img').forEach(img => {
      img.setAttribute('draggable', 'false');
    });

    // Swipe / Drag support
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    const onTouchStart = (e) => {
      isDragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      track.style.transition = 'none';
    };

    const onTouchMove = (e) => {
      if (!isDragging) return;
      currentX = e.touches ? e.touches[0].clientX : e.clientX;
      const diff = currentX - startX;
      track.style.transform = `translateX(-${index * slideWidth - diff}px)`;
    };

    const onTouchEnd = () => {
      if (!isDragging) return;
      isDragging = false;
      const diff = currentX - startX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          scrollBackward();
        } else {
          scrollForward();
        }
      } else {
        updatePosition(true);
      }
    };

    // Mouse events
    track.addEventListener('mousedown', onTouchStart);
    track.addEventListener('mousemove', onTouchMove);
    track.addEventListener('mouseup', onTouchEnd);
    track.addEventListener('mouseleave', onTouchEnd);

    // Touch events
    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: true });
    track.addEventListener('touchend', onTouchEnd);

   // Only prevent horizontal scroll, allow vertical scroll
slider.addEventListener('wheel', e => {
  if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
    e.preventDefault(); // Prevent only if horizontal
  }
}, { passive: false });

  });
});

  } catch(e) { console.error(e); }
})();
})();
